import cx from 'classnames'

import { ReactComponent as HandbookSvg } from 'assets/icons/handbook_16--solid.svg'

import TitleEmojiPicker from 'components/ActionBar/ArticleTitleBar/TitleEmojiPicker/TitleEmojiPicker'
import { Button } from 'components/Button/Button'
import { DropdownTrigger } from 'components/DropdownTrigger/DropdownTrigger'
import { HandbookV2 } from '../../types'

import { FolderIcon } from 'common/FolderIcon'
import { Spinner } from 'common/Spinner/Spinner'
import Styles from './HandbookIcon.module.scss'
import { useHandbookUpdate } from './HandbookSettings/hooks/useHandbookUpdate'
import EmojiPickerStyles from './Sidebar/HandbookItems.module.scss'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'

const DEFAULT_COLOR = Styles.gold50

const HandbookIcon = observer(
  ({
    handbook,
    className,
    emojiClass,
    folder,
    isInDefaultProject,
    canEdit,
  }: {
    handbook?: Pick<HandbookV2, 'emoji' | 'key' | 'folder'> | null
    className?: string
    emojiClass?: string
    folder?: boolean
    isInDefaultProject?: boolean
    canEdit?: boolean
  }) => {
    const store = useRootStore().handbooks
    const { onUpdate, isUpdating } = useHandbookUpdate(store, handbook as HandbookV2)

    const Icon = () => {
      if (folder) {
        return (
          <FolderIcon
            className={cx(Styles.defaultIcon, emojiClass, Styles.folderIcon)}
            defaultFolder={!!isInDefaultProject}
          />
        )
      }

      return <HandbookSvg className={emojiClass} style={{ fill: DEFAULT_COLOR }} />
    }

    if (isUpdating) return <Spinner className={Styles.loadingEmoji} />

    return canEdit ? (
      <DropdownTrigger placement="bottom-end" popoverClassName={EmojiPickerStyles.emojiPickerPopover}>
        <div className={cx(className, Styles.triggerWrap)}>
          <Button variant="tertiary" size="sm" className={cx(Styles.emojiTrigger)}>
            <Icon />
          </Button>
        </div>
        {(close) => (
          <TitleEmojiPicker
            className={EmojiPickerStyles.emojiPickerContainer}
            onSelect={(emoji) => {
              const newEmoji = emoji?.native || null
              onUpdate({ emoji: newEmoji })
              close()
            }}
            removable
            showEmojiPicker={true}
            toggleShowEmojiPicker={() => {}}
          />
        )}
      </DropdownTrigger>
    ) : (
      <div className={cx(className, Styles.triggerWrap, Styles.emojiTrigger)}>
        <Icon />
      </div>
    )
  },
)

export default HandbookIcon
